import * as ActionTypes from '../actionTypes';

// eslint-disable-next-line import/prefer-default-export
export function getList() {
    return async (dispatch) => {
        return new Promise(async (resolve) => {
            dispatch({
                type: ActionTypes.STARTING_GET_ALERT_LIST,
                nextToken: '',
            });

            return resolve({
                items: [],
                nextToken: '',
            });
        });
    };
}

export function markSeen() {
    return async (dispatch) => {
        return new Promise(async (resolve) => {
            dispatch({
                type: ActionTypes.STARTING_MARK_SEEN_ALERT,
            });

            return resolve({ success: true });
        });
    };
}
